// RAPPEL DES OBJECTIFS du projet (migration 049), au tableau de bord.
//
// Ce que la recherche doit servir, et combien d'insights servent déjà chaque
// objectif. Un objectif que rien ne sert se voit : c'est là qu'il manque de la
// recherche. Rien n'est affiché tant qu'aucun objectif n'est déclaré : la
// déclaration se fait dans les Options.
import { useObjectives } from '../api/queries';
import { buttonClass, Eyebrow } from '../components/ui';
import { Link } from '../router';

const day = (iso: string) => iso.split('-').reverse().join('/');

export function ObjectivesReminder({ projectId }: { projectId: string }) {
  const query = useObjectives(projectId);
  const objectives = query.data?.objectives ?? [];
  if (objectives.length === 0) return null;

  return (
    <section className="metrics objectives-reminder">
      <div className="metrics-head">
        <Eyebrow>Objectifs</Eyebrow>
        <h2 className="t-h2">Ce que la recherche doit servir</h2>
        <Link to={`/projet/${encodeURIComponent(projectId)}/options`} className={buttonClass('ghost')}>
          Gérer les objectifs
        </Link>
      </div>
      <ul className="objectives-list">
        {objectives.map((o) => (
          <li key={o.id} className={`zy-card objective-card${o.insight_count === 0 ? ' is-empty' : ''}`}>
            <span className="t-mono">{o.importance === 'principal' ? 'Principal' : 'Secondaire'}{o.due ? ` · ${day(o.due)}` : ''}</span>
            <strong>{o.title}</strong>
            {o.metric ? <span className="objective-metric">{o.metric}</span> : null}
            <Link to={`/projet/${encodeURIComponent(projectId)}/insights`} className="objective-count">
              {o.insight_count === 0
                ? 'Aucun insight ne le sert encore'
                : `${o.insight_count} insight${o.insight_count > 1 ? 's' : ''} le ser${o.insight_count > 1 ? 'vent' : 't'}`}
            </Link>
          </li>
        ))}
      </ul>
    </section>
  );
}
